/**
 * @generated SignedSource<<0d7a2083c13d248fcd2f2578c0c3ab21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueTypePickerIssueTypeShared$data = {
  readonly color: IssueTypeColor;
  readonly description: string | null | undefined;
  readonly id: string;
  readonly isEnabled: boolean;
  readonly name: string;
  readonly pinnedFields: ReadonlyArray<{
    readonly __typename: "IssueFieldDate";
    readonly dataType: IssueFieldDataType;
    readonly id: string;
    readonly name: string;
  } | {
    readonly __typename: "IssueFieldNumber";
    readonly dataType: IssueFieldDataType;
    readonly id: string;
    readonly name: string;
  } | {
    readonly __typename: "IssueFieldSingleSelect";
    readonly dataType: IssueFieldDataType;
    readonly id: string;
    readonly name: string;
  } | {
    readonly __typename: "IssueFieldText";
    readonly dataType: IssueFieldDataType;
    readonly id: string;
    readonly name: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }> | null | undefined;
  readonly " $fragmentType": "IssueTypePickerIssueTypeShared";
};
export type IssueTypePickerIssueTypeShared$key = {
  readonly " $data"?: IssueTypePickerIssueTypeShared$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerIssueTypeShared">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueTypePickerIssueTypeShared"
};

(node as any).hash = "ad8f00cd9d8c47c96b5370cc5d7c1878";

export default node;
